const TokenTierCard = ({ data, tier, isSelected, onclick }) => {
  return (
    <div
      className={`${
        isSelected ? "border-blue-600" : "border-white/10"
      } border-[0.5px] rounded-lg overflow-hidden text-sm`}
    >
      <div
        className={`text-center py-1 ${
          isSelected ? "bg-blue-600" : "bg-white/5"
        }`}
      >
        <p
          className={`${
            isSelected ? "font-semibold text-white" : "font-thin text-white/40"
          }`}
        >
          {tier}
        </p>
      </div>
      <div className="px-3 sm:px-10 py-3 w-full text-sm text-white/40 flex flex-row items-center justify-between">
        <div className="flex flex-col">
          <p className="flex flex-row items-center font-thin text-sm gap-1">
            <span className="">
              Tokens: <span className="font-semibold">{data?.token}</span>
            </span>
            <span className="">
              Usage: <span className="font-semibold">{data?.usage}</span>
            </span>
          </p>
          <p className="flex flex-row items-center font-thin">
            Price:{" "}
            <span className="relative text-2xl font-normal ml-3">
              <span className="text-xs font-thin mr-[3px] absolute top-[8px] left-[-8px]">
                $
              </span>
              {data?.price}
              <span className="text-xs font-thin ml-1">CAD</span>
            </span>
          </p>
        </div>
        <div>
          <button
            onClick={() => onclick()}
            className="border-[0.5px] border-white/10 px-3 py-[3px] text-white/30 cursor-pointer hover:text-white/20 transition-all duration-500 rounded-md"
          >
            Buy
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenTierCard;
